import { render, staticRenderFns } from "./goodsSection.vue?vue&type=template&id=1ba63686&"
import script from "./goodsSection.vue?vue&type=script&lang=js&"
export * from "./goodsSection.vue?vue&type=script&lang=js&"
import style0 from "./goodsSection.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports